import {
    LoanApplicantIdDocumentType,
    LoanApplicationSubmitSource2,
} from '@servicetitan/financing-api-client';
import { ApplicationData } from './ApplicationDataStore';

export interface ApplicationDataDefaultValues {
    customerFirstName: string;
    customerLastName: string;
    customerEmail: string;
    customerPhone: string;
    serviceLocationStreet: string;
    serviceLocationUnit: string;
    serviceLocationCity: string;
    serviceLocationState: string;
    serviceLocationZip: string;
    source: LoanApplicationSubmitSource2;
}

export const getApplicationDataDefaultValues: (
    data: ApplicationDataDefaultValues,
) => ApplicationData = ({
    customerFirstName,
    customerLastName,
    customerEmail,
    customerPhone,
    serviceLocationStreet,
    serviceLocationState,
    serviceLocationUnit,
    serviceLocationCity,
    serviceLocationZip,
    source,
}) => ({
    applicant: {
        primaryApplicant: {
            firstName: customerFirstName,
            lastName: customerLastName,
            email: customerEmail,
            primaryPhone: customerPhone,
            applicantId: {
                applicantIdDocumentType: LoanApplicantIdDocumentType.DriversLicense,
                documentId: undefined,
                issueDate: undefined,
                expirationDate: undefined,
                state: undefined,
            },
            dateOfBirth: undefined,
            ssn: undefined,
            employment: {
                employerName: undefined,
                grossMonthlyIncome: undefined,
            },
            jobDetails: {
                address: {
                    street: serviceLocationStreet,
                    address2: serviceLocationUnit,
                    city: serviceLocationCity,
                    state: serviceLocationState,
                    zip: serviceLocationZip,
                },
            },
        },
    },
    mailingAddress: {
        workPerformedAtAddress: true,
        primaryApplicant: {
            address: {
                street: serviceLocationStreet,
                address2: serviceLocationUnit,
                city: serviceLocationCity,
                state: serviceLocationState,
                zip: serviceLocationZip,
            },
        },
    },
    serviceProperty: {
        primaryApplicant: {
            housingType: undefined,
            propertyType: undefined,
        },
        improvement: undefined,
    },
    coApplicant: {
        hasCoApplicant: false,
    },
    externalApplication: {
        firstName: customerFirstName,
        lastName: customerLastName,
        email: customerEmail,
        primaryPhone: customerPhone,
        address: {
            street: serviceLocationStreet,
            address2: serviceLocationUnit,
            city: serviceLocationCity,
            state: serviceLocationState,
            zip: serviceLocationZip,
        },
    },
    source,
});
